import { render, staticRenderFns } from "./MedicalExaminations.vue?vue&type=template&id=6999bf26&"
import script from "./MedicalExaminations.vue?vue&type=script&lang=js&"
export * from "./MedicalExaminations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports